/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import styles from './styles';
import { Box, Dialog, Divider, Grid, IconButton, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { CancelPresentationRounded, SaveRounded } from '@mui/icons-material';
import { COLORS } from '../../../../shared/config/colors';
import useUnsavedChanges from '../../../../hooks/useUnsavedChanges';
import { HYDRAULICS_RUN_NOTES_MAX_LENGTH } from '../../../../utils/constants';

const NotesModal = ({
  notes,
  setNotes,
  rowData,
  onCloseClick,
  isOpen,
  updateData,
}) => {
  const classes = styles();
  const [properties, setProperties] = useState([]);
  const {
    unSavedExists,
    handleClose,
    UnsavedChangesModal
  } = useUnsavedChanges(properties, onCloseClick);

  const closeHandler = () => {
    if (unSavedExists) {
      handleClose(false);
      return;
    }
    setProperties([]);
    onCloseClick();
  };

  useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    const { isDirty, name = '', ...rest } = rowData || {};
    const updatedData = {
      ...rest,
      runName: name.length > 15 ? name.substring(0, 15) + '...' : name,
    };
    setProperties([updatedData]);
  }, []);

  return (
        <Dialog
            open={isOpen}
            onClose={closeHandler}
            maxWidth={'lg'}
            fullWidth={true}
            className={classes.dialogModal}
        >
            <Box className={classes.dialogTitle}>
                <Typography variant="subtitle1" className={classes.headerTitle}>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography variant="subtitle1" color="textPrimary">
                                    {`${properties[0]?.runName} | Note`}
                                </Typography>
                                <Typography variant='h6' color={COLORS.LIGHT_GREY} fontWeight='500'>
                                    (Max {HYDRAULICS_RUN_NOTES_MAX_LENGTH} Characters)
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item>
                            <IconButton onClick={closeHandler}>
                                <CancelPresentationRounded fontSize="large" />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Typography>

            </Box>
            <Divider />
            <Grid container>
                    <Grid item xs={12}>
                        <Box sx={{ p: 1, position: 'relative' }}>
                            <TextField
                                id="outlined-multiline-static"
                                multiline
                                value={notes || ''}
                                onChange={(e) => {
                                  setNotes(e.target.value);
                                  setProperties(prev => [
                                    {
                                      ...prev[0],
                                      isDirty: true,
                                    }
                                  ]);
                                }}
                                rows={4}
                                fullWidth
                                inputProps={{ maxLength: HYDRAULICS_RUN_NOTES_MAX_LENGTH }}
                            />
                            <Box
                                sx={{
                                  position: 'absolute',
                                  bottom: 8,
                                  right: 12,
                                  fontSize: '0.75rem',
                                  color: 'text.secondary',
                                }}
                            >
                               {(notes || '').length} / {HYDRAULICS_RUN_NOTES_MAX_LENGTH}
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={12} >
                        <Box className={classes.saveIcon}>
                            <IconButton
                                disabled={!properties[0]?.isDirty}
                                onClick={() => {
                                  updateData(rowData?._id, 'notes', notes.trim());
                                  setProperties(prev => [
                                    {
                                      ...prev[0],
                                      isDirty: false,
                                    }
                                  ]);
                                  onCloseClick();
                                }}
                            >
                                <SaveRounded fontSize='large' />
                            </IconButton>
                        </Box>
                    </Grid>
                    <UnsavedChangesModal />
                </Grid>
        </Dialog>
  );
};
NotesModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  rowData: PropTypes.object,
  updateData: PropTypes.func,
  notes: PropTypes.string,
  setNotes: PropTypes.func
};
NotesModal.defaultProps = {
  selectedJob: {}
};

export default NotesModal;
